import { axiosSwagger } from "@/axios";

export const state = {
    returned: {
        loading: false,
        data: [],
        total: 0,
    }

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.returned.loading = loading;
    },
    setData: (state, data) => {
        state.returned.data = data;
    },
    setTotal: (state, total) => {
        state.returned.total = total;
    },
    remove: (state, id) => {
        state.returned.data = state.returned.data.filter((el) => el.id !== id);
    },
}


export const actions = {
    // FILE RETURNED
    async readReturnedPost({ commit }) {
        commit("loading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Returned/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const customData = ( response.data );

            commit("setData", customData);
            commit("setTotal", customData.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async readTotalDUReturnedPostResponse({ commit }) {
        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Returned/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const customData = ( response.data );

            commit("setTotal", customData.length);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async updatePostedFilePost({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FilePosting/Post/${id}`)
        .then((response) => {
            commit('remove', id);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async deleteFilePosting({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/FilePosting/Remove/${id}`)
        .then((response) => {
            commit('remove', id);
            
            return response;
        });
    }
}


// eslint-disable-next-line no-unused-vars
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
        return arrayData.filter( e => {
            // e filter data if classified and if user is not the one who upload
            const isClassified = e?.isClassified || false;
            const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
            
            if(!isClassified){
                return true;
            }
            else if(isClassified && e.fileManager.applicationUserId !== userData?.userId){
                return false
            }
        
            return true;
        });
    }
  
    return [];
};